export type { SuspenseCacheOptions } from "./SuspenseCache.js";
export { getSuspenseCache } from "./getSuspenseCache.js";
